import React from 'react';
const STATS = [{
  value: '3000+',
  label: 'операций'
}, {
  value: '20+',
  label: 'лет практики'
}, {
  value: '400+',
  label: 'операций ежегодно'
}];
export function AboutSurgeon() {
  return <section className="w-full bg-white" data-id="element-1">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-6 lg:py-20" data-id="element-2">
        <div data-id="element-3">
          <div data-id="element-4">
            <h2 className="text-xl font-semibold leading-tight tracking-tight text-slate-900 sm:text-2xl lg:text-3xl" data-id="element-5">
              Павел Петрович Иванов — хирург-ортопед, специалист по
              эндопротезированию
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-600" data-id="element-6">
              С 2015 года — хирург НМИЦ им. Р.Р. Вредена. Специализация —
              эндопротезирование суставов нижней конечности
            </p>
            <p className="mt-4 text-lg leading-relaxed text-slate-600" data-id="element-7">
              Проходил стажировки в ведущих клиниках Европы. Регулярно повышает
              квалификацию и участвует в международных конференциях.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-8">
              {STATS.map(stat => <div key={stat.label} className="rounded-2xl border border-blue-100 bg-blue-50/60 p-5 text-center" data-id="element-9">
                  <div className="text-2xl font-semibold text-blue-700 sm:text-3xl" data-id="element-10">
                    {stat.value}
                  </div>
                  <div className="mt-1 text-base text-slate-600" data-id="element-11">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}